import { Box, CircularProgress, InputBase } from '@material-ui/core';
import React, { KeyboardEvent, useEffect, useState } from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { useTranslation } from '../../../hooks/useTranslation';
import { SearchBarFilterOptions } from '../types/SearchBarFilterOptions';

interface SearchFieldProps {
  searchBarFilter: SearchBarFilterOptions;
  setSearchBarFilter;
  requestLoading: boolean;
}
export const SearchField = ({ searchBarFilter, setSearchBarFilter, requestLoading }: SearchFieldProps) => {
  const { palette } = useCustomTheme();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchBarFilter((s) => ({ ...s, searchTerm: inputValue }));
    }, 600);

    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  const handleOnChange = (e) => {
    setInputValue(e.target.value);
  };

  const { getTextIdTranslation } = useTranslation();
  return (
    <CustomPaper fill="grey.light" style={{ height: '56px', padding: '0 16px' }}>
      <Box height="100%" width="100%" display="flex" alignItems="center">
        <i className={'material-icons-outlined'} style={{ paddingRight: '16px', color: palette.text.primary }}>
          search
        </i>
        <InputBase
          autoFocus
          fullWidth
          onChange={(e) => {
            handleOnChange(e);
          }}
          onKeyDown={(e: KeyboardEvent) => {
            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
              e.preventDefault();
            }
          }}
          placeholder={getTextIdTranslation(`SEARCH_${searchBarFilter.filterByType}`) as string}
          endAdornment={
            requestLoading && <CircularProgress color={'secondary'} size={24} style={{ display: 'flex' }} />
          }
          style={{ color: palette.text.primary }}
        />
      </Box>
    </CustomPaper>
  );
};
